import Instance from '../../../utils/Axios';

// New Actions for the app

const GetTiposAtrasos = () => async (dispatch) => {
  await Instance()
    .get(`/tipoatrasos`)
    .then(({ data }) => {
      dispatch({ type: 'GET_TIPOATRASOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTiposAtrasos;
